export function stripHtmlTags(string: string) {
    return string.replace(/(<([^>]+)>)/gi, '');
}
